import teaserBoxLink from './link';
import teaserBoxHeadline from './headline';
import teaserBoxSubHeadline from './sub-headline';

/**
 * @param {Object} asset - content asset
 * @param {string} boxTextColor -text color.
 * @param {string} backgroundStyle - background style.
 * @returns {string} teaser content block HTML
 */
export default (asset, boxTextColor, backgroundStyle) =>
    `<div class="teaser-box ${boxTextColor} ${asset.teaserBoxAlign} ${backgroundStyle}">
        <!--- teaser headline --->
        ${teaserBoxHeadline(asset.teaserHeadline)}
        <!--- teaser sub headline --->
        ${teaserBoxSubHeadline(asset.teaserSubHeadline)}
        <!--- teaser link --->
        ${teaserBoxLink(asset.teaserLinkTarget, asset.teaserLinkText || Resources.SHOW_MORE)}
    </div>`;
